import OverflowMenuPresentationPropsDefault from "@insite/mobius/OverflowMenu/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@stoneage/XDL/types";
import { css } from "styled-components";


export default {
    defaultProps: {
        mergeCss: true,
        ...OverflowMenuPresentationPropsDefault,
        buttonProps: {
            ...OverflowMenuPresentationPropsDefault?.buttonProps,
            color: "common.ui3",
            shape: "pill",
            buttonType: "solid",
            shadow: false,
            css: css`
                &&&,
                &:hover,
                &:focus {
                    padding: 0;
                    justify-content: center;
                    width: 34px;
                }
                &&& > span[class*="IconWrapper-"] {
                    top: 2px;
                    width: 24px;
                    height: 24px;
                    svg {
                        width: 24px;
                        height: 24px;
                    }
                }
            `,
            icon: {
                src: "",
                position: "right"
            }
        },
        cssOverrides: {
            wrapper: css`
                display: flex;
                align-items: center;
                justify-content: end;
                z-index: 10;
                width: 34px;
                height: 34px;
                `,
            menu: css``,
            menuItem: css`
                display: inline;
                width: 100%;
                background: ${getColor("common.white")};
                color: ${getColor("common.ui1")} !important;
                &:hover,
                &:focus,
                &:active {
                    color: ${getColor("text.main")} !important;
                    background: ${getColor("common.ui4")};
                }
                &:disabled {
                    opacity: 0.5;        
                }
                button {
                    margin-left: 0 !important;
                }
            `,
        },
        iconProps: { src: "MoreVertical" },
    },
} as xBaseTheme["overflowMenu"];
